import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector     : 'empty-layout',
    templateUrl  : './empty.component.html',
    styleUrls    : ['./empty.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class EmptyLayoutComponent implements OnInit, OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private schemeObserver: MutationObserver;
    private viewport: HTMLMetaElement | null;
    private viewportContent: string | null;
    private readonly syncMobileViewport = (): void =>
    {
        const mobile = window.matchMedia('(max-width: 959px)').matches;
        const rgb = getComputedStyle(this._document.body).getPropertyValue('--fuse-bg-card-rgb').trim();
        this._document.documentElement.style.backgroundColor = mobile && rgb ? `rgb(${rgb})` : '';
        if (!this.viewport || this.viewportContent == null) {
            return;
        }
        this.viewport.setAttribute(
            'content',
            mobile
                ? 'width=device-width, initial-scale=1.0, minimum-scale=1.0, user-scalable=no'
                : this.viewportContent,
        );
    };

    constructor(@Inject(DOCUMENT) private _document: Document)
    {
    }

    ngOnInit(): void
    {
        this.viewport = this._document.querySelector('meta[name="viewport"]');
        this.viewportContent = this.viewport?.getAttribute('content') ?? null;
        this._document.documentElement.classList.add('auth-document-scroll');
        this.syncMobileViewport();
        this.schemeObserver = new MutationObserver(this.syncMobileViewport);
        this.schemeObserver.observe(this._document.body, { attributes: true, attributeFilter: ['class'] });
        window.matchMedia('(max-width: 959px)').addEventListener('change', this.syncMobileViewport);
    }

    ngOnDestroy(): void
    {
        this.schemeObserver?.disconnect();
        window.matchMedia('(max-width: 959px)').removeEventListener('change', this.syncMobileViewport);
        this._document.documentElement.classList.remove('auth-document-scroll');
        this._document.documentElement.style.backgroundColor = '';
        if (this.viewport && this.viewportContent != null) {
            this.viewport.setAttribute('content', this.viewportContent);
        }
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
